<template>
  <div class="content-outside" :style="{ 'height': ( (testList.length+1) * 45)+'px'}">
    <div class="table-content">
      <div class="fixedcol">
        <div>头部州市名</div>
        <div v-for=" (item, index ) in testList" :key="index">{{ item.zhoushi}}</div>
      </div>
      <div class="scrollcols-content">
        <div class="scrollcols">
          <div class="everycols nullcol"></div>
          <div class="everycols">头部名称 随便取</div>
          <div class="everycols">头部名称 随便取</div>
          <div class="everycols">头部名称 随便取</div>
          <div class="everycols">头部名称 随便取</div>
          <div class="everycols">头部名称 随便取</div>
          <div class="everycols">头部名称 随便取</div>
          <div class="everycols">头部名称 随便取</div>
          <div class="everycols">操作</div>
        </div>

        <div class="scrollcols" v-for=" (item, index) in testList" :key="index">
          <div class="everycols nullcol"></div>
          <div class="everycols">{{ item.test1 }}</div>
          <div class="everycols">{{ item.test2 }}</div>
          <div class="everycols">{{ item.test3 }}</div>
          <div class="everycols">{{ item.test4 }}</div>
          <div class="everycols">{{ item.test5 }}</div>
          <div class="everycols">{{ item.test6 }}</div>
          <div class="everycols">{{ item.test7 }}</div>
          <div class="everycols" @click="btndetail(item.id) ">查看详情</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "customTable",
  data() {
    return {
      testList: [
        {
          id: "1",
          zhoushi: "州市名",
          test1: "1",
          test2: "2",
          test3: "3",
          test4: "4",
          test5: "5",
          test6: "6",
          test7: "7"
        },
        {
          id: "2",
          zhoushi: "州市名",
          test1: "1",
          test2: "2",
          test3: "3",
          test4: "4",
          test5: "5",
          test6: "6",
          test7: "7"
        },
        {
          id: "3",
          zhoushi: "州市名",
          test1: "1",
          test2: "2",
          test3: "3",
          test4: "4",
          test5: "5",
          test6: "6",
          test7: "7"
        },
        {
          id: "4",
          zhoushi: "州市名",
          test1: "1",
          test2: "2",
          test3: "3",
          test4: "4",
          test5: "5",
          test6: "6",
          test7: "7"
        },
        {
          id: "5",
          zhoushi: "州市名",
          test1: "1",
          test2: "2",
          test3: "3",
          test4: "4",
          test5: "5",
          test6: "6",
          test7: "7"
        }
      ]
    };
  },
  methods: {
    btndetail(id) {
      console.log("------选中的id:", id);
    }
  }
};
</script>
<style lang="less" scoped>
.content-outside {
  width: 100%;
  overflow: hidden;
}
.table-content {
  width: 100%;
  min-height: 45px;
  position: relative;
  overflow: hidden;
}
.fixedcol {
  width: 102px;
  min-height: 45px;
  position: fixed;
  left: 0;
  line-height: 45px;
  z-index: 99;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.04);
  border-radius: 3px 0px 0px 3px;
}
.scrollcols-content {
  width: 100%;
  overflow: auto;
  padding-bottom: 20px;
}
.scrollcols {
  width: 100%;
  height: 45px;
  display: flex;
  line-height: 44px;
  text-align: center;
}
.everycols {
  min-width: 100px;
}
.nullcol {
  width: 102px !important;
}
</style>
